import { css } from 'linaria';

export const BannerImageStyles = css`
  display: block;
  width: 100%;
  overflow: hidden;
  border-radius: var(--rounding-m);
`;
